import { module } from 'modujs';
import Swiper from 'swiper';
import { A11y, Controller } from 'swiper/modules';
import gsap from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

        this.centerSlider;

        // Items
        this.$items = this.$('items');

        // UI
        this.$leftOffSlider = this.$('slider-0')[0]
        this.$leftSlider = this.$('slider-1')[0]
        this.$centerSlider = this.$('slider-2')[0]
        this.$rightSlider = this.$('slider-3')[0]
        this.$rightOffSlider = this.$('slider-4')[0]

        // UI Navigation
        this.$prevButton = this.$('prev')[0]
        this.$nextButton = this.$('next')[0]

        // Set GSAP defaults
        gsap.defaults({
            duration: 0.4, // Définit la durée par défaut des animations
            ease: 'power4.out', // Définit l'easing par défaut
        });
    }

    init() {
        Swiper.use([A11y, Controller]);

        let args = {
            speed: 700,
            a11y: {
                enabled: true,
                scrollOnFocus: false
            },

            slidesPerView: 1,
            loop: true,
            spaceBetween: 0
        };

        this.leftOffSlider = new Swiper(this.$leftOffSlider, {
            ...args,
            grabCursor: false,
            allowTouchMove: false
        });

        this.leftSlider = new Swiper(this.$leftSlider, {
            ...args,
            grabCursor: false,
            allowTouchMove: false
        });

        this.centerSlider = new Swiper(this.$centerSlider, {
            ...args
        });

        this.rightSlider = new Swiper(this.$rightSlider, {
            ...args,
            grabCursor: false,
            allowTouchMove: false
        });

        this.rightOffSlider = new Swiper(this.$rightOffSlider, {
            ...args,
            grabCursor: false,
            allowTouchMove: false
        });

        this.animateSlideOut('.c-tile-carousel.-main');
        this.animateSlideIn(this.centerSlider.slides[this.centerSlider.activeIndex]);

        this.centerSlider.controller.control = [this.leftOffSlider, this.leftSlider, this.rightSlider, this.rightOffSlider]

        this.bindEvents()
    }

    bindEvents() {
        this.$prevButton.addEventListener('click', () => this.centerSlider.slidePrev())
        this.$nextButton.addEventListener('click', () => this.centerSlider.slideNext())

        this.$leftOffSlider.addEventListener('click', () => this.centerSlider.slidePrev())
        this.$leftSlider.addEventListener('click', () => this.centerSlider.slidePrev())
        this.$rightSlider.addEventListener('click', () => this.centerSlider.slideNext())
        this.$rightOffSlider.addEventListener('click', () => this.centerSlider.slideNext())

        this.centerSlider.on('transitionStart', () => {
            this.animateSlideOut('.c-tile-carousel.-main');
        })

        this.centerSlider.on('transitionEnd', (swiper) => {
            const currentSlide = swiper.slides[swiper.activeIndex];
            this.animateSlideIn(currentSlide);
        })
    }

    animateSlideOut(selector) {
        const tl = new gsap.timeline();
        tl.to(`${selector} .c-tile_title`, { opacity: 0, xPercent: -5 })
            .to(`${selector} .c-tile_date`, { opacity: 0, xPercent: -5 }, 0)
            .to(`${selector} .c-tile_tags`, { opacity: 0, xPercent: -5 }, 0);
    }

    animateSlideIn(slide) {
        const tl = new gsap.timeline();
        tl.to(slide.querySelector('.c-tile_title'), { opacity: 1, xPercent: 0 })
            .to(slide.querySelector('.c-tile_date'), { opacity: 1, xPercent: 0 }, "<0.1")
            .to(slide.querySelector('.c-tile_tags'), { opacity: 1, xPercent: 0 }, "<0.1");
    }

    unbindEvents() {
        this.$prevButton.removeEventListener('click', () => this.centerSlider.slidePrev())
        this.$nextButton.removeEventListener('click', () => this.centerSlider.slideNext())

        this.$leftOffSlider.removeEventListener('click', () => this.centerSlider.slidePrev())
        this.$leftSlider.removeEventListener('click', () => this.centerSlider.slidePrev())
        this.$rightSlider.removeEventListener('click', () => this.centerSlider.slideNext())
        this.$rightOffSlider.removeEventListener('click', () => this.centerSlider.slideNext())
    }

    destroy() {
        super.destroy();
        this.unbindEvents();
        this.leftOffSlider?.destroy(true, true)
        this.leftSlider?.destroy(true, true)
        this.centerSlider?.destroy(true, true)
        this.rightSlider?.destroy(true, true)
        this.rightOffSlider?.destroy(true, true)
    }
}
